/**
 * Created by JurY on 16/06/17.
 */

angular.module("screensApp")

  .controller("LangController", function ($scope, $rootScope) {
    // Show Help guide
    $rootScope.setLanguage = function (language) {
      $rootScope.config.LanguageId = language;
      $rootScope.setLocale(language);
      SIR("changeLanguage", language);
      $rootScope.$$phase || $rootScope.$apply();
    };
  });
